import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import BGImageDisplay from "../../Components/BGImageDisplay/BGImageDisplay";
import ThanksImage from "../../assets/ThankYou/Thank You@2x.png";

//  background-image: url(${plogobg});

const ThanksStyles = styled.div`
  display: grid;
  height: calc(100vh - 100px);
`;

const Thanks = () => {
  return (
    <Container initial="hidden" animate="show" exit="exit">
      <ThanksStyles>
        <BGImageDisplay objectfit={"fill"} bgimage={ThanksImage} />
      </ThanksStyles>
    </Container>
  );
};
export default Thanks;
